import {BaseStore, globalStore} from "../../../stem-core/state/Store";
import {field} from "../../../stem-core/state/StoreField.js";
import {apiClient} from "../../connection/BlinkApiClient.js";
import {Merchant} from "../MerchantStore";
import {MerchantEmailSender} from "./MerchantEmailSender";


@globalStore
export class MerchantEmailingSettings extends BaseStore("MerchantEmailingSettings") {
    @field("Merchant") merchant: Merchant;
    @field("MerchantEmailSender") defaultSender: MerchantEmailSender;
    @field(String) emailReplyTo: string;
    @field(Array) bccEmails: string[];
    @field(Boolean) sendDonationCancelEmail: boolean;
}

export async function apiUpdateMerchantEmailingSettings(request: any): Promise<any> {
    return apiClient.post("merchant/update_emailing_settings/", request);
}

export async function apiMerchantEmailingBreakdown(request: any): Promise<any> {
    return apiClient.get("/merchant/get_emailing_breakdown/", request);
}
